import { Component } from '@angular/core';

@Component({
  selector: 'app-foryou',
  templateUrl: './foryou.component.html',
  styleUrl: './foryou.component.scss'
})
export class ForyouComponent {

}
